<li [id]="htmlId" *ngIf="listType==='unordered' || listType==='unstyled' || listType==='ordered'">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</li>

<dt [id]="htmlId" *ngIf="listType==='described'">
  {{description}}
</dt>
<dd *ngIf="listType==='described'">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</dd>

<li class="list-group-item d-flex justify-content-between align-items-center list-group-item-{{themeVariant}}"
    *ngIf="listType==='group-ul' || listType==='group'"
    [id]="htmlId">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</li>

<button class="list-group-item list-group-item-action list-group-item-{{themeVariant}}"
        *ngIf="listType==='group-div'"
        [id]="htmlId">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>

<li [id]="htmlId" class="list-group-item" *ngIf="listType==='group-flush'">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</li>

<a [id]="htmlId"
    class="list-group-item list-group-item-action flex-column align-items-start"
    *ngIf="listType==='group-custom-content'">
  <div class="d-flex w-100 justify-content-between">
    <h5 class="mb-1">{{customContentItemHeading}}</h5>
    <small>{{customContentHeadingSmallText}}</small>
  </div>
  <p class="mb-1">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </p>
  <small>{{customContentSmallText}}</small>
</a>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
